import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import store from "@/store";

function route(path, view, name) {
    return {
        name: name || view,
        path: path,
        component: (resolve) => import(
            `@/views/${view}.vue`
            ).then(resolve)
    };
}

function userRoutesList() {
    const screenWidth = document.documentElement.clientWidth;
    const screenHeight = document.documentElement.clientHeight;
    // if (screenHeight > screenWidth) {
    if (screenHeight > screenWidth && store.state.accessToken) {
    // if (store.state.accessToken) {
        return paths.map((path) => route(path.path, path.view, path.name))
            .concat([{ path: '*', redirect: '/devices' },]);
    } else if (screenHeight < screenWidth) {
        return [
            {
                path: '/',
                name: 'empty',
                component: (resolve) => import(
                    `@/views/DesktopPage.vue`
                    ).then(resolve)
            },
            {
                path: '*',
                redirect: '/',
            },
        ];
    } else {
        return [
            {
                path: '/login',
                name: 'login',
                component: (resolve) => import(
                    `@/views/Login.vue`
                    ).then(resolve)
            },
            {
                path: '/resetpassword',
                name: 'resetpassword',
                component: (resolve) => import(
                    `@/views/ResetPassword.vue`
                    ).then(resolve)
            },
            {
                path: '/confirmemail',
                name: 'confirmemail',
                component: (resolve) => import(
                    `@/views/ConfirmEmail.vue`
                    ).then(resolve)
            },
            {
                path: '/setpassword',
                name: 'setpassword',
                component: (resolve) => import(
                    `@/views/SetNewPassword.vue`
                    ).then(resolve)
            },
            {
                path: '*',
                redirect: '/login',
            },
        ];
    }
}

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: userRoutesList(),
});

export default router;